import { ExternalLink, InlineEmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import { GithubIcon } from "@octopusdeploy/design-system-icons";
import { useRef, useState } from "react";
import { GitHubAccessCodeModal } from "~/areas/configuration/components/Git/GitHubAccessCodeModal";
import { isGitHubAppTrustedFlow } from "~/areas/configuration/components/Git/getGitHubAppSettings";
import { repository } from "~/clientInstance";
import { PortalEmptyStateOnboarding } from "~/components/GettingStarted/PortalEmptyStateOnboarding";
import { beginGitHubAppRedirectFlow } from "../beginGitHubAppRedirectFlow";
export const GitConnectionAuthorizeOnboarding = () => {
    const authorizeUrl = useRef(repository.GitHubApp.getAuthorizeAppUrl(window.location.href));
    const [isGitHubAccessCodeModalOpen, setIsGitHubAccessCodeModalOpen] = useState(false);
    const onboardingTextForGitHubAuthorize = "Clicking the button below will redirect you to GitHub. Continue to follow the prompts to connect Octopus to your GitHub account.";
    const handleAuthorize = () => {
        beginGitHubAppRedirectFlow(authorizeUrl.current);
        // Show authorization code modal for non-trusted flow
        if (!isGitHubAppTrustedFlow()) {
            setIsGitHubAccessCodeModalOpen(true);
        }
    };
    const handleCloseGitHubAccessCodeModal = () => {
        setIsGitHubAccessCodeModalOpen(false);
    };
    return (<>
            <PortalEmptyStateOnboarding title={"Connect Octopus and GitHub"} description={onboardingTextForGitHubAuthorize} actions={[
            {
                type: "button",
                buttonType: "secondary",
                icon: <GithubIcon size={16}/>,
                label: "Authorize the Octopus Deploy GitHub App",
                onClick: handleAuthorize,
            },
        ]} learnMore={<ExternalLink href={"GitHubApp"}>Learn More</ExternalLink>}/>
            <GitHubAccessCodeModal isOpen={isGitHubAccessCodeModalOpen} onClose={handleCloseGitHubAccessCodeModal}/>
        </>);
};
type GitConnectionInstallOnboardingProps = {
    onExternalLinkClick?: () => void;
};
export const GitConnectionInstallOnboarding = ({ onExternalLinkClick }: GitConnectionInstallOnboardingProps) => {
    const installUrl = useRef(repository.GitHubApp.getInstallationUrl(window.location.href));
    const handleInstallClick = (event: React.MouseEvent | undefined) => {
        if (onExternalLinkClick) {
            onExternalLinkClick();
        }
        beginGitHubAppRedirectFlow(installUrl.current);
    };
    const onboardingTextForGitHubInstall = "Enable smooth and secure connectivity to GitHub by installing the Octopus Deploy GitHub App in your GitHub account.";
    return (<InlineEmptyStateOnboarding illustration={"EmptyState"} title="Configure the GitHub App" description={onboardingTextForGitHubInstall} actions={{
            external: {
                label: "Configure the Octopus Deploy GitHub App",
                onClick: handleInstallClick,
            },
        }} learnMore={{ path: "GitHubApp", label: "Learn More" }}/>);
};
